module.exports = __webpack_public_path__ + "img/py.d50715ab.jpg";